<template>
  <mi-drawer
    class="validation-details-drawer"
    :class="opened? 'opened' : 'closed'"
    :model-value="true"
    :mini="!opened"
    width="355"
    mini-width="57"
    side="right"
    overlay
    bordered
    persistent
  >
    <div class="mini-drawer">
      <h4 v-show="opened" class="header">Details</h4>
      <mi-btn
        :ripple="false"
        icon="arrows-right"
        icon-type
        icon-size="18px"
        class="collapse-icon drawer-btn q-mt-sm"
        :class="{ 'rotate-180': !opened }"
        dense
        fab
        flat
        @click="toggleDrawerOpened()"
      ></mi-btn>
    </div>
    <div v-show="opened && validDetails" class="validation-details__info q-pb-md">
      <div class="validation-details__info-section">
        <h5 class="title__small">Validation ID </h5>
        <p>{{ $route.params.id || '' }}</p>
      </div>
      <div class="flex row">
        <div class="validation-details__info-section fixed-width">
          <h5 class="title__small">Product Model</h5>
          <p v-if="bomValidationDetails.productModelType === 'PRODUCT_MODEL'">
            {{ bomValidationDetails.businessName || '-' }}
          </p>
          <p v-if="bomValidationDetails.productModelType === 'USER_EXPORTS'">
            {{ bomValidationDetails.userExportsName || '-' }}
          </p>
        </div>
        <div class="validation-details__info-section">
          <h5 class="title__small">Planning Period</h5>
          <p>
            {{ removePrefixFromPlanningPeriod(bomValidationDetails?.planningPeriodRange?.from) }}
          </p>
        </div>
      </div>
      <div class="flex row">
        <div class="validation-details__info-section fixed-width">
          <h5 class="title__small">Creation Date</h5>
          <p>{{ creationDateFormatted || '' }}</p>
        </div>
        <div class="validation-details__info-section">
          <h5 class="title__small">Component ID</h5>
          <p>{{ bomValidationDetails.componentId || '' }}</p>
        </div>
      </div>
      <div class="flex row">
        <div class="validation-details__info-section fixed-width">
          <h5 class="title__small">Precondition</h5>
          <p class="precondition">{{ formatPrecondition }}</p>
        </div>
      </div>
    </div>
  </mi-drawer>
</template>

<script>
  import formatDate from '@/utils/formatDate'
  import { computed, ref } from 'vue'
  import MiBtn from '../../../../packages/@mi-library/MiBtn/MiBtn.vue'
  import { removePrefixFromPlanningPeriod } from '../../../../utils/planningPeriod'

  export default {
    name: 'BomValidationResultsDetails',
    components: { MiBtn },
    props: {
      bomValidationDetails: {
        type: Object,
        required: true
      }
    },
    emits: ['is-drawer-opened'],
    setup(props, { emit }) {
      const opened = ref(true)

      const toggleDrawerOpened = () => {
        opened.value = !opened.value
        emit('is-drawer-opened', opened.value)
      }

      const creationDateFormatted = computed(() => (props.bomValidationDetails.startDate
        ? formatDate(props.bomValidationDetails.startDate) : ''))

      const formatPrecondition = computed(() => (props.bomValidationDetails.precondition?.length > 0
        ? props.bomValidationDetails?.precondition.join(';') : '--'))

      const validDetails = computed(() => Object.keys(props.bomValidationDetails).length > 0
        && props.bomValidationDetails.businessName != null
        && props.bomValidationDetails.componentId != null
        && props.bomValidationDetails.planningPeriodRange != null
        && props.bomValidationDetails.startDate)

      return {
        opened,
        toggleDrawerOpened,
        creationDateFormatted,
        validDetails,
        removePrefixFromPlanningPeriod,
        formatPrecondition
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mini-drawer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    align-items: center;
  }

  .fixed-width {
    width: 204px;
  }

  // stylelint-disable declaration-no-important
  ::v-deep(.q-drawer) {
    top: 132px !important;
  }

  .header {
    margin: 0;
  }

  h5 {
    margin: 0;
    font-size: 14px;
  }

  .bom-validation-details {
    min-width: 380px;
    min-height: 170px;
    background-color: $mi-silver-50;
  }

  .validation-details {
    line-height: 150%;

    ::v-deep(.q-drawer-container) {
      margin-left: 350px !important;
    }

    &__info-section {
      padding: 16px 16px 0;

      p {
        margin-top: 4px;
        margin-bottom: 0;
      }
    }

    &__info-small-section {
      padding: 8px 0 0;
      align-items: baseline;

      p {
        margin-bottom: 0;
      }
    }

    &__info {
      margin: 16px;
      background-color: #eaedf366;
      font-size: 14px;

      .title {
        font-weight: 700;
        font-size: 14px;
        gap: 10px;
        display: flex;
        flex-direction: row;
        font-family: $mi-typography-font-family;
        align-items: baseline;

        &__small {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }

  .precondition {
    width: 290px;
    word-break: break-word;
  }
</style>
